import { onDocumentReady } from '@theme/utilities';

const STORAGE_KEY = 'theme-last-shopping-path';

/** @type {string[]} */
const EXCLUDED_PATH_PREFIXES = ['/cart', '/checkouts', '/account/logout'];

/**
 * @param {string} pathname
 * @returns {boolean}
 */
function isExcludedPath(pathname) {
  return EXCLUDED_PATH_PREFIXES.some((prefix) => pathname.startsWith(prefix));
}

/**
 * Persists the current storefront path so cart "continue shopping" can return there.
 */
export function trackLastShoppingPath() {
  if (isExcludedPath(window.location.pathname)) return;

  try {
    sessionStorage.setItem(STORAGE_KEY, window.location.pathname + window.location.search);
  } catch (_) {
    // sessionStorage may be unavailable in strict private browsing
  }
}

/**
 * @param {string} [fallback]
 * @returns {string | undefined}
 */
export function resolveContinueShoppingUrl(fallback) {
  try {
    if (document.referrer) {
      const referrer = new URL(document.referrer);

      if (referrer.origin === window.location.origin && !isExcludedPath(referrer.pathname)) {
        return referrer.pathname + referrer.search;
      }
    }

    const stored = sessionStorage.getItem(STORAGE_KEY);

    if (stored) {
      const storedPath = new URL(stored, window.location.origin).pathname;

      if (!isExcludedPath(storedPath)) {
        return stored;
      }
    }
  } catch (_) {
    // Invalid referrer or storage
  }

  return fallback;
}

/**
 * @param {ParentNode} [root]
 */
export function initContinueShoppingLinks(root = document) {
  for (const link of root.querySelectorAll('[data-continue-shopping]')) {
    if (!(link instanceof HTMLAnchorElement)) continue;

    const fallback = link.getAttribute('href') ?? undefined;
    const destination = resolveContinueShoppingUrl(fallback);

    if (destination) {
      link.href = destination;
    }
  }
}

trackLastShoppingPath();

onDocumentReady(() => {
  initContinueShoppingLinks();
});
